// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"XKK3j","listingPageNewsletterWidget":"JMa1m","cardWrapper":"CWfHq","onlyWap":"q6wRp","newsLetterBanner":"EjJ1e","MLauto":"q584k","onlyWeb":"zM3oE"};